module.exports = __webpack_public_path__ + "static/media/ImproveSpeed.a3adb945.svg";